import { Alert, Avatar, Box, Button, Card, CardActions, CardContent, Chip, CircularProgress, createTheme, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, Grid, IconButton, InputLabel, MenuItem, Select, Snackbar, Switch, TextField, Tooltip, Typography } from "@mui/material";
import LogService from "../../services/LogService";
import ILog from "../../types/Log";
import { useEffect, useState } from "react";
import ConfigUtils from "../../utils/Config";
import { formatCurrency, getCurrencySymbol } from "../../utils/Factura";
import IServicio from "../../types/Servicio";
import IMetodoPago from "../../types/MetodoPago";
import IAlert from "../../types/Alert";
import AddIcon from '@mui/icons-material/Add';
import * as constantes from "../../common/Constantes";
import { MetodoPagoCodigo } from "../../common/Constantes";
import ConfigService from "../../services/ConfigService";
import { CONFIGTYPES } from "../../types/Config";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import ReplayIcon from "@mui/icons-material/Replay";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useNavigate } from "react-router-dom";
import { IPlan } from "../../types/Plan";
import StripeService from "../../services/StripeService";
import IEntidadFacturacion, { IDatosFacturacion, IInvoiceCounterEntidad } from "../../types/EntidadFacturacion";
import EntidadFacturacionForm from "./EntidadFacturacionForm";
import CambioAnioNumeracionDialog from "./CambioAnioNumeracionDialog";
import { getAnioEnCurso } from "../../utils/Numeracion";
import FacturacionService from "../../services/FacturacionService";

interface IServicioErrors {
    nombre?: string;
    concepto?: string;
    precio?: string;
    impuesto?: string;
    frecuencia?: string;
};

const initialServicio: IServicio = {
  nombre: "",
  concepto: "",
  precio: 0,
  impuesto: 0,
  recurrente: false,
  frecuencia: null,
  facturable: true,
  activo: true,
  userId: ""
};

const Servicios = () => {
    const theme = createTheme();
    const history = useNavigate();
    const [alert, setAlert] = useState<IAlert>({ open: false, severity: 'info', msg: '' });

    const [servicios, setServicios] = useState<IServicio[]>(ConfigUtils.getServicios());
    const [modalServicio, setModalServicio] = useState<boolean>(false);
    const [isEditServicio, setIsEditServicio] = useState<boolean>(false);
    const [selectedServicio, setSelectedServicio] = useState<IServicio | null>(null);
    const [loadingServicio, setLoadingServicio] = useState<boolean>(false);
    const [modalDeleteServicio, setModalDeleteServicio] = useState<boolean>(false);

    const [errorsServicio, setErrorsServicio] = useState<IServicioErrors>({});
    const [confirmNoFacturable, setConfirmNoFacturable] = useState(false);
    
    const [metodosPago, setMetodosPago] = useState<IMetodoPago[]>(ConfigUtils.getMetodosPago());
    const metodosPagoDisponibles = constantes.getMetodosPagoDisponibles(ConfigUtils.getPais() || 'ES');
    const [modalMetodoPago, setModalMetodoPago] = useState<boolean>(false);
    const [selectedMetodo, setSelectedMetodo] = useState<IMetodoPago | null>(null);
    const [loadingMetodo, setLoadingMetodo] = useState<boolean>(false);
    const [modalDeleteMetodo, setModalDeleteMetodo] = useState<boolean>(false);
    const [errorMetodo, setErrorMetodo] = useState<string>("");

    const [precioTotal, setPrecioTotal] = useState(0);
    const [inputPrecioBase, setInputPrecioBase] = useState(selectedServicio?.precio ? selectedServicio.precio.toString().replace(".", ",") : "0,00");

    const [currency, setCurrency] = useState(ConfigUtils.getUserCurrency() || 'EUR');
    const [inputCurrency, setInputCurrency] = useState('EUR');
    const [modalCurrency, setModalCurrency] = useState(false);
    const [loadingCurrency, setLoadingCurrency] = useState(false);

    const [datosFacturacionPrincipal, setDatosFacturacionPrincipal] = useState<IDatosFacturacion | null>(ConfigUtils.getDatosFacturacion());
    const [entidadesAdicionales, setEntidadesAdicionales] = useState<IEntidadFacturacion[]>(ConfigUtils.getDatosFacturacionAdicional());
    const [plan, setPlan] = useState<IPlan>();
    const [modalEntidad, setModalEntidad] = useState(false);
    const [selectedEntidad, setSelectedEntidad] = useState<IEntidadFacturacion | undefined>(undefined);
    const [modalCambioAnio, setModalCambioAnio] = useState(false);
    // _id null = entidad principal (no tiene objeto IEntidadFacturacion propio)
    const [entidadCambioAnio, setEntidadCambioAnio] = useState<{ _id: string | null; pais?: string } | null>(null);
    const [modalToggleEntidad, setModalToggleEntidad] = useState(false);
    const [entidadToToggle, setEntidadToToggle] = useState<IEntidadFacturacion | null>(null);
    const [loadingToggleEntidad, setLoadingToggleEntidad] = useState(false);
    const [contadores, setContadores] = useState<IInvoiceCounterEntidad[]>([]);
    const [loadingPlan, setLoadingPlan] = useState(true);
    const [loadingContadores, setLoadingContadores] = useState(entidadesAdicionales.length > 0);

    useEffect(() => {
        StripeService.getPlanData(ConfigUtils.getUserId())
          .then((response: any) => {
            setPlan(response.data);
          })
          .catch((e: any) => {
            if (e.response?.status === 401) {
                localStorage.clear();
                history(constantes.R_HOME);
            } else {
                const error: ILog = { method: 'Servicios.Component.getPlanData', level: 'error', message: e.message, meta: e.response };
                LogService.logError(error);
            }
          })
          .finally(() => setLoadingPlan(false));
        setDatosFacturacionPrincipal(ConfigUtils.getDatosFacturacion())
    }, []);

    useEffect(() => {
        if (entidadesAdicionales.length === 0) {
            setLoadingContadores(false);
            return;
        }

        setLoadingContadores(true);
        FacturacionService.getInvoiceCounters(ConfigUtils.getUserId())
          .then((response) => {
            setContadores(response.data);
          })
          .catch((e: any) => {
            if (e.response?.status === 401) {
                localStorage.clear();
                history(constantes.R_HOME);
            } else {
                const error: ILog = { method: 'Servicios.Component.getInvoiceCounters', level: 'error', message: e.message, meta: e.response };
                LogService.logError(error);
            }
          })
          .finally(() => setLoadingContadores(false));
    }, [entidadesAdicionales.length]);

    const handleCloseAlert = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setAlert({ open: false, severity: 'info', msg: '' });
    };

    const setIsUpdateServicio = (servicio: IServicio) => {
        setIsEditServicio(true);
        setSelectedServicio(servicio);
        const precioTotal = servicio.precio + (servicio.precio * servicio.impuesto) / 100;
        setInputPrecioBase(servicio.precio.toFixed(2).replace(".", ","));
        setPrecioTotal(precioTotal);
        setModalServicio(true);
    };

    const closeModalServicio = () => {
        setIsEditServicio(false);
        setSelectedServicio(initialServicio);
        setErrorsServicio({});
        setPrecioTotal(0);
        setInputPrecioBase("");
        setModalServicio(false);
    };

    const validateServicio = () => {
        const e: IServicioErrors = {};

        if (!selectedServicio?.nombre?.trim()) e.nombre = "El nombre es obligatorio";

        const existeNombre = servicios.some(s =>
            s.nombre.trim().toLowerCase() === selectedServicio?.nombre?.toLowerCase() &&
            s.activo === selectedServicio?.activo &&
            s._id !== selectedServicio?._id
        );

        if (existeNombre) {
            e.nombre = "Ya existe un servicio con este nombre";
        }

        if (!selectedServicio?.concepto?.trim()) e.concepto = "El concepto es obligatorio";
        if (selectedServicio?.facturable && (!selectedServicio?.precio || selectedServicio.precio <= 0)) {
          e.precio = "El precio debe ser mayor que 0";
        }
        if (selectedServicio?.impuesto === null || selectedServicio?.impuesto === undefined)
            e.impuesto = "Debe seleccionar un impuesto";

        if (selectedServicio?.recurrente && !selectedServicio?.frecuencia)
            e.frecuencia = "Debe seleccionar una frecuencia";

        setErrorsServicio(e);

        return Object.keys(e).length === 0;
    };

    const saveServicio = async () => {
        if (!selectedServicio) return;
        setLoadingServicio(true);
        selectedServicio.userId = ConfigUtils.getUserId();

        try {
          const response: any = await ConfigService.createServicio(selectedServicio);
          ConfigUtils.addConfig(CONFIGTYPES.servicios.toString(), response.data);
          const newServicios: IServicio[] = [response.data, ...servicios];
          setServicios(newServicios);
          setAlert({ open: true, severity: 'success', msg: 'Servicio creado correctamente' });
          window.dispatchEvent(new Event('popstate'));
        } catch (e: any) {
            if (e.response.status === 401) {
                localStorage.clear();
                history(constantes.R_HOME);
            } else {
                const error: ILog = { method: 'Servicios.Component.saveServicio', level: 'error', message: e.message, meta: e.response };
                LogService.logError(error);
                setAlert({ open: true, severity: 'error', msg: e?.response?.data?.message || 'Error al crear servicio' });
            }
        } finally {
          closeModalServicio();
          setLoadingServicio(false);
        }
    };

    const updateServicio = async () => {
        if (!selectedServicio) return;
        setLoadingServicio(true);
        try {
            const response = await ConfigService.updateServicio(selectedServicio._id!, selectedServicio);
            const newServicios: IServicio[] = servicios.map((s) => s._id === response.data._id ? response.data : s);
            setServicios(newServicios);
            ConfigUtils.editConfig(CONFIGTYPES.servicios.toString(), response.data);
            setAlert({ open: true, severity: 'success', msg: 'Servicio actualizado correctamente' });
        } catch (e: any) {
            if (e.response.status === 401) {
                localStorage.clear();
                history(constantes.R_HOME);
            } else {
                const error: ILog = { method: 'Servicios.Component.updateServicio', level: 'error', message: e.message, meta: e.response };
                LogService.logError(error);
                setAlert({ open: true, severity: 'error', msg: e?.response?.data?.message || 'Error al actualizar servicio' });
            }
        } finally {
          closeModalServicio();
          setLoadingServicio(false);
        }
    };

    const toggleServicioActivo = async () => {
        if (!selectedServicio) return;
        setLoadingServicio(true);

        try {
            const payload = {
                activo: !selectedServicio.activo,
                userId: ConfigUtils.getUserId()
            };
            const response = await ConfigService.updateServicioActivo(selectedServicio._id!, payload);
            const newServicios: IServicio[] = [...servicios.map(s => s._id === response.data._id ? response.data : s)];
            setServicios(newServicios);
            ConfigUtils.editConfig(CONFIGTYPES.servicios.toString(), response.data);
            setAlert({ open: true, severity: 'success', msg: `Servicio ${response.data.activo ? 'activado' : 'desactivado'} correctamente` });
        } catch (e: any) {
            if (e.response.status === 401) {
                localStorage.clear();
                history(constantes.R_HOME);
            } else {
                const error: ILog = { method: 'Servicios.Component.toggleServicioActivo', level: 'error', message: e.message, meta: e.response };
                LogService.logError(error);
                setAlert({ open: true, severity: 'error', msg: e?.response?.data?.message || 'Error al actualizar servicio' });
            }
        } finally {
          setModalDeleteServicio(false);
          setSelectedServicio(null);
          setLoadingServicio(false);
        }
    };

    const closeModalMetodoPago = () => {
        setSelectedMetodo(null);
        setModalMetodoPago(false);
        setErrorMetodo("");
    };

    const validateMetodoPago = (): boolean => {
        if (!selectedMetodo) {
            setErrorMetodo("Debe seleccionar un método de pago");
            return false;
        }
        setErrorMetodo("");
        return true;
    };

    const saveMetodoPago = async () => {
        if (!selectedMetodo) return;
        setLoadingMetodo(true);
        selectedMetodo.userId = ConfigUtils.getUserId();

        try {
          const response: any = await ConfigService.createMetodoPago(selectedMetodo);
          ConfigUtils.addConfig(CONFIGTYPES.metodosPago.toString(), response.data);
          const newMetodos: IMetodoPago[] = [response.data, ...metodosPago];
          setMetodosPago(newMetodos);
          setAlert({ open: true, severity: 'success', msg: 'Método de pago creado correctamente' });
          window.dispatchEvent(new Event('popstate'));
        } catch (e: any) {
            if (e.response.status === 401) {
                localStorage.clear();
                history(constantes.R_HOME);
            } else {
                const error: ILog = { method: 'Servicios.Component.saveMetodoPago', level: 'error', message: e.message, meta: e.response };
                LogService.logError(error);
                setAlert({ open: true, severity: 'error', msg: e?.response?.data?.message || 'Error al crear el método de pago' });
            }
        } finally {
          closeModalMetodoPago();
          setLoadingMetodo(false);
        }
    };

    const toggleMetodoPagoActivo = async () => {
        if (!selectedMetodo) return;
        setLoadingMetodo(true);

        try {
            const payload = {
                activo: !selectedMetodo.activo,
                userId: ConfigUtils.getUserId()
            };
            const response = await ConfigService.updateMetodoPagoActivo(selectedMetodo._id!, payload);
            const newMetodos: IMetodoPago[] = [...metodosPago.map(s => s._id === response.data._id ? response.data : s)];
            setMetodosPago(newMetodos);
            ConfigUtils.editConfig(CONFIGTYPES.metodosPago.toString(), response.data);
            setAlert({ open: true, severity: 'success', msg: `Método de pago ${response.data.activo ? 'activado' : 'desactivado'} correctamente` });
        } catch (e: any) {
            if (e.response.status === 401) {
                localStorage.clear();
                history(constantes.R_HOME);
            } else {
                const error: ILog = { method: 'Servicios.Component.toggleMetodoPagoActivo', level: 'error', message: e.message, meta: e.response };
                LogService.logError(error);
                setAlert({ open: true, severity: 'error', msg: e?.response?.data?.message || 'Error al actualizar método de pago' });
            }
        } finally {
          setModalDeleteMetodo(false);
          setSelectedMetodo(null);
          setLoadingMetodo(false);
        }
    };

    const updateUserCurrency = async () => {
        setLoadingCurrency(true);
                
        try {
          await ConfigService.updateUserCurrency(ConfigUtils.getUserId(), inputCurrency);
          ConfigUtils.addConfig(CONFIGTYPES.currency.toString(), inputCurrency);
          setCurrency(inputCurrency);
          setAlert({ open: true, severity: 'success', msg: 'Divisa actualizada correctamente' });
          setModalCurrency(false);
        } catch (e: any) {
            if (e.response?.status === 401) {
                localStorage.clear();
                history(constantes.R_HOME);
            } else {
                const error: ILog = { method: 'Servicios.Component.updateUserCurrency', level: 'error', message: e.message, meta: e.response };
                LogService.logError(error);
                setAlert({ open: true, severity: 'error', msg: e?.response?.data?.message || 'Error al actualizar la divisa' });
            }
        } finally {
          setLoadingCurrency(false);
        }
    };

    const handleEntidadSuccess = (entidad: IEntidadFacturacion) => {
        // Un cambio de NIF (cambio de titular) añade la identidad anterior como entidad desactivada: se recarga la lista
        // completa que el formulario ya ha guardado en la configuración.
        const entidades = ConfigUtils.getDatosFacturacionAdicional();
        const existia = entidadesAdicionales.length;
        setEntidadesAdicionales(entidades);
        setModalEntidad(false);
        setAlert({ open: true, severity: 'success', msg: !selectedEntidad
            ? 'Entidad de facturación creada correctamente'
            : entidades.length > existia
                ? `Entidad "${entidad.nombre}" actualizada: la entidad anterior se ha guardado desactivada con sus facturas`
                : 'Entidad de facturación actualizada correctamente' });

        // Al editar, entidadesAdicionales.length puede no cambiar, así que el useEffect que carga los contadores no se
        // vuelve a disparar solo — y un cambio de titular estrena numeración, así que hay que refrescarlos aquí.
        FacturacionService.getInvoiceCounters(ConfigUtils.getUserId())
          .then((response) => setContadores(response.data))
          .catch((e: any) => {
              const error: ILog = { method: 'Servicios.Component.handleEntidadSuccess', level: 'error', message: e.message, meta: e.response };
              LogService.logError(error);
          });
    };

    const handleToggleEntidadActiva = async () => {
        if (!entidadToToggle) return;
        setLoadingToggleEntidad(true);
        const nuevoEstado = !entidadToToggle.active;

        try {
            if (nuevoEstado) {
                await ConfigService.activateEntidadFacturacion(ConfigUtils.getUserId(), entidadToToggle._id);
            } else {
                await ConfigService.deactivateEntidadFacturacion(ConfigUtils.getUserId(), entidadToToggle._id);
            }
            const entidadActualizada: IEntidadFacturacion = { ...entidadToToggle, active: nuevoEstado };
            ConfigUtils.editConfig(CONFIGTYPES.datosFacturacionAdicional.toString(), entidadActualizada);
            setEntidadesAdicionales(prev => prev.map(e => e._id === entidadActualizada._id ? entidadActualizada : e));
            setAlert({ open: true, severity: 'success', msg: `Entidad de facturación ${nuevoEstado ? 'activada' : 'desactivada'} correctamente` });
            // Al activar, la API puede haber actualizado la serie al año en curso
            if (nuevoEstado) {
                FacturacionService.getInvoiceCounters(ConfigUtils.getUserId())
                  .then((response) => setContadores(response.data))
                  .catch((e: unknown) => {
                      const message = e instanceof Error ? e.message : String(e);
                      const error: ILog = { method: 'Servicios.Component.handleToggleEntidadActiva', level: 'error', message, meta: message };
                      LogService.logError(error);
                  });
            }
            setModalToggleEntidad(false);
            setEntidadToToggle(null);
        } catch (e: any) {
            if (e.response?.status === 401) {
                localStorage.clear();
                history(constantes.R_HOME);
            } else {
                const error: ILog = { method: 'Servicios.Component.handleToggleEntidadActiva', level: 'error', message: e.message, meta: e.response };
                LogService.logError(error);
                setAlert({ open: true, severity: 'error', msg: e?.response?.data?.message || `Error al ${nuevoEstado ? 'activar' : 'desactivar'} la entidad de facturación` });
            }
        } finally {
            setLoadingToggleEntidad(false);
        }
    };

    const getUltimoNumero = (entidadId: string | null) => {
        const contador = contadores.find(c => (c.entidadId ?? null) === entidadId);
        if (!contador) return 'Numeración no configurada';
        // Sin facturas no hay número que mostrar, pero la serie sí: es la única forma de saber qué
        // series están ya creadas (cada entidad debe tener un prefijo distinto). El contador se
        // reinicia cada año, así que "0" solo dice que esa serie no tiene facturas: se indica su
        // año (el de la propia serie, que puede ser de un año atrasado).
        if (contador.counter === 0) {
            const anioSerie = contador.serie.match(/\d{4}$/)?.[0];
            return `Serie ${contador.serie} · Sin facturas emitidas${anioSerie ? ` en ${anioSerie}` : ''}`;
        }
        return `Última factura: ${contador.serie}-${contador.counter.toString().padStart(6, '0')}`;
    };

    // Año en curso de una entidad: el de la zona horaria de su país (mismo criterio que el servidor).
    const anioEnCursoDe = (entidadId: string | null) =>
        getAnioEnCurso(entidadId ? entidadesAdicionales.find(e => e._id === entidadId)?.pais : datosFacturacionPrincipal?.pais);

    // Al activar una entidad con la serie de otro año, la API la actualiza al año en curso: se avisa en la confirmación.
    const avisoNumeracionAlActivar = (entidad: IEntidadFacturacion | null): string => {
        if (!entidad || !necesitaNuevoAnio(entidad._id)) return '';
        const contador = contadores.find(c => (c.entidadId ?? null) === entidad._id);
        if (!contador) return '';
        const anioSerie = contador.serie.match(/\d{4}$/)?.[0];
        const serieNueva = `${contador.serie.replace(/\d{4}$/, '')}${anioEnCursoDe(entidad._id)}`;
        return ` Su numeración es de ${anioSerie ?? 'otro año'}: al activarla se actualizará a la serie ${serieNueva}, empezando por la ${serieNueva}-000001.`;
    };

    const necesitaNuevoAnio = (entidadId: string | null) => {
        const contador = contadores.find(c => (c.entidadId ?? null) === entidadId);
        if (!contador) return false;
        return contador.serie.slice(-2) !== anioEnCursoDe(entidadId).toString().slice(-2);
    };

    try {
        return (
            <Grid>

                <Grid container spacing={2} sx={{p: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Métodos de pago</Typography>
                    <Grid container spacing={2}>
                        <Grid item md={12}>
                            {metodosPagoDisponibles.some(
                              (mp) => !metodosPago.some((m) => m.codigo === mp.codigo)
                            ) && (
                              <Button
                                onClick={() => setModalMetodoPago(true)}
                                color="success"
                                variant="contained"
                              >
                                <Typography variant="body1" sx={{ fontSize: '15px', fontWeight: 'bold', color: 'white' }}>Añadir método de pago</Typography>
                              </Button>
                            )}
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: theme.spacing(1) }}>
                      {metodosPago.length === 0 ? (
                        <Typography>No se han encontrado métodos de pago</Typography>
                      ) : (
                        metodosPago.map((m) => (
                          <Grid item key={m._id || m.codigo}>
                            <Chip
                              key={m._id}
                              label={m.nombre}
                              variant={m.activo ? "outlined" : "filled"}
                              color={m.activo ? "primary" : "default"}
                              sx={{
                                padding: "6px 10px",
                                fontSize: "14px",
                                opacity: m.activo ? 1 : 0.6,
                              }}
                              onDelete={() => {
                                setSelectedMetodo(m);
                                setModalDeleteMetodo(true);
                              }}
                              deleteIcon={
                                m.activo ? (
                                  <CloseIcon sx={{ fontSize: 16 }} />
                                ) : (
                                  <ReplayIcon sx={{ fontSize: 16 }} />
                                )
                              }
                            />
                          </Grid>
                        ))
                      )}
                    </Grid>
                </Grid>
                <Grid container spacing={2} sx={{p: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Servicios</Typography>
                    <Grid container spacing={2}>
                        <Grid item md={12}>
                            <Button onClick={() => {setModalServicio(true); setSelectedServicio(initialServicio)}} color="success" variant="contained">
                                <Typography variant="body1" sx={{ fontSize: '15px', fontWeight: 'bold', color: 'white' }}>Añadir servicio</Typography>
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: theme.spacing(1) }}>
                      {servicios.length === 0 ? (
                        <Typography>No se han encontrado servicios</Typography>
                      ) : (
                        servicios.map((s) => (
                          <Grid item xs={12} sm={6} md={3} key={s._id}>
                            <Card variant="outlined" sx={{ backgroundColor: s.activo ? 'white' : '#f0f0f0' }}>
                              <CardContent>
                                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                  {s.nombre}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                  {s.concepto}
                                </Typography>
                                <Typography variant="body2">
                                    Precio: {formatCurrency(s.precio, currency)}
                                    {s.recurrente && ` / mes`}
                                </Typography>
                                <Typography variant="body2">Impuesto: {s.impuesto}%</Typography>
                                <Chip
                                  label={s.facturable ? "Facturable" : "NO Facturable"}
                                  color={s.facturable ? "success" : "error"}
                                  variant={s.facturable ? "filled" : "outlined"}
                                  size="small"
                                  sx={{ mt: 1, fontWeight: 'bold' }}
                                />
                              </CardContent>
                              <CardActions>
                                <Button
                                  size="small"
                                  disabled={!s.activo}
                                  onClick={() => setIsUpdateServicio(s)}
                                >
                                  Editar
                                </Button>
                                <Button
                                  size="small"
                                  color="error"
                                  onClick={() => {
                                    setSelectedServicio(s);
                                    setModalDeleteServicio(true);
                                  }}
                                >
                                  {s.activo ? 'Desactivar' : 'Activar'}
                                </Button>
                              </CardActions>
                            </Card>
                          </Grid>
                        ))
                      )}
                    </Grid>
                </Grid>

                {/* AÑADIR SERVICIO */}
                <Dialog open={modalServicio} maxWidth="md" fullWidth onClose={closeModalServicio}>
                    <DialogContent>
                        <Typography variant="h4" sx={{ display: 'inline-flex' }}>
                            <Avatar sx={{ margin: theme.spacing(1), backgroundColor: '#2e7d32' }}>
                                <AddIcon />
                            </Avatar>
                            <div style={{ margin: '10px auto' }}>
                                {isEditServicio ? 'Editar servicio' : 'Añadir servicio'}
                            </div>
                        </Typography>

                        {/* Facturable */}
                            <Grid item xs={12} md={6} sx={{ mb: 2 }}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={selectedServicio?.facturable}
                                            onChange={(e) => {
                                                const value = e.target.checked;
                                                if (!value && selectedServicio?.facturable) {
                                                    setConfirmNoFacturable(true);
                                                    return;
                                                }
                                                setSelectedServicio(s => ({ ...s!, facturable: value }));
                                            }}
                                        />
                                    }
                                    label="Facturable"
                                />
                            </Grid>
                                
                        <Grid container spacing={1}>
                                
                            {/* Nombre */}
                            <Grid item xs={12} md={4}>
                                <TextField
                                    fullWidth
                                    label="Nombre*"
                                    value={selectedServicio?.nombre || ""}
                                    onChange={(e) => setSelectedServicio(s => ({ ...s!, nombre: e.target.value }))}
                                    error={Boolean(errorsServicio?.nombre)}
                                    helperText={errorsServicio?.nombre}
                                />
                            </Grid>
                                
                            {/* Concepto */}
                            <Grid item xs={12} md={8}>
                                <TextField
                                    fullWidth
                                    label="Concepto*"
                                    value={selectedServicio?.concepto || ""}
                                    onChange={(e) =>
                                        setSelectedServicio(s => ({ ...s!, concepto: e.target.value }))
                                    }
                                    error={Boolean(errorsServicio?.concepto)}
                                    helperText={errorsServicio?.concepto}
                                />
                            </Grid>
                                
                            {/* BLOQUE PRECIO E IMPUESTOS */}
                            <Grid item xs={12}>
                              <Box sx={{ p: 1, borderRadius: 2 }}>
                                <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>Precio e impuestos</Typography>
                                <Grid container spacing={2} alignItems="center">

                                  {/* Precio base */}
                                  <Grid item xs={12} sm={2}>
                                    <TextField
                                      fullWidth
                                      type="text"
                                      label={`Precio base (${getCurrencySymbol(currency)})*`}
                                      value={
                                        selectedServicio?.precio !== undefined && selectedServicio?.precio !== null
                                        ? inputPrecioBase
                                        : "0,00"
                                      }
                                      onChange={(e) => {
                                        let raw = e.target.value;
                                        setInputPrecioBase(raw);
                                        const normalized = raw.replace(",", ".");
                                        if (/^\d*([.,]\d*)?$/.test(raw)) {
                                          const precio = parseFloat(normalized);
                                          setSelectedServicio((s) => {
                                            const impuesto = s?.impuesto ?? 0;
                                            const precioTotalCalc = !isNaN(precio)
                                              ? precio + (precio * impuesto) / 100
                                              : 0;
                                            setPrecioTotal(precioTotalCalc);
                                            return {
                                              ...s!,
                                              precio: !isNaN(precio) ? precio : 0,
                                            };
                                          });
                                        }
                                      }}
                                      onBlur={() => {
                                        const precio = selectedServicio?.precio ?? 0;
                                        const formatted = precio.toFixed(2).replace(".", ",");
                                        setInputPrecioBase(formatted);
                                      }}
                                      error={Boolean(errorsServicio?.precio)}
                                      helperText={errorsServicio?.precio}
                                    />
                                  </Grid>
                                  
                                  {/* Impuesto */}
                                  <Grid item xs={12} sm={2}>
                                    <TextField
                                      fullWidth
                                      select
                                      label="Impuesto (%)*"
                                      value={selectedServicio?.impuesto}
                                      onChange={(e) => {
                                        setSelectedServicio(s => {
                                          const impuesto = Number(e.target.value);
                                          const precio = s!.precio ?? 0;
                                          const precioTotal = precio + (precio * impuesto) / 100;
                                          setPrecioTotal(precioTotal);                             
                                          return {
                                            ...s!,
                                            impuesto
                                          };
                                        })
                                      }}
                                    >
                                      {constantes.IMPUESTOS.map((impuesto) => (
                                        <MenuItem key={impuesto} value={impuesto}>
                                          {impuesto}%
                                        </MenuItem>
                                      ))}
                                    </TextField>
                                  </Grid>

                                  {/* Precio total */}
                                  <Grid item xs={12} sm={2}>
                                    <TextField
                                      fullWidth
                                      type="number"
                                      label={`Precio total (${getCurrencySymbol(currency)})`}
                                      value={precioTotal.toFixed(2)}
                                      InputProps={{ readOnly: true, sx: {
                                        backgroundColor: '#f0f0f0',
                                        color: '#555',
                                        '& .MuiOutlinedInput-notchedOutline': {
                                          borderColor: '#bdbdbd'
                                        }
                                      }}}
                                    />
                                  </Grid>
                                </Grid>
                              </Box>
                            </Grid>
                                
                            {/* Recurrente */}
                            <Grid item xs={12} md={3}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={selectedServicio?.recurrente || false}
                                            onChange={(e) =>
                                                setSelectedServicio(s => ({
                                                    ...s!,
                                                    recurrente: e.target.checked,
                                                    frecuencia: e.target.checked ? (selectedServicio?.frecuencia || "mensual") : null
                                                }))
                                            }
                                        />
                                    }
                                    label="Recurrente"
                                />
                            </Grid>
                                
                            {/* Frecuencia → SOLO si recurrente */}
                            {selectedServicio?.recurrente && (
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        fullWidth
                                        label="Frecuencia*"
                                        select
                                        value={selectedServicio?.frecuencia || "mensual"}
                                        onChange={(e) =>
                                            setSelectedServicio(s => ({ ...s!, frecuencia: e.target.value }))
                                        }
                                        error={Boolean(errorsServicio?.frecuencia)}
                                        helperText={errorsServicio?.frecuencia}
                                    >
                                        <MenuItem value="mensual">Mensual</MenuItem>
                                    </TextField>
                                </Grid>
                            )}

                        </Grid>
                    </DialogContent>
                        
                    {loadingServicio ? (
                        <Grid container>
                            <CircularProgress style={{ margin: '20px auto' }} />
                        </Grid>
                    ) : (
                        <DialogActions>
                            <Button onClick={() => {
                                if (!validateServicio()) return;
                                isEditServicio ? updateServicio() : saveServicio();
                            }}>Guardar</Button>
                            <Button onClick={closeModalServicio}>Cancelar</Button>
                        </DialogActions>
                    )}
                </Dialog>

                {/* CONFIRMAR NO FACTURABLE */}
                <Dialog open={confirmNoFacturable} maxWidth="sm">
                    <DialogContent>
                        <Typography>
                            ¿Seguro que quieres marcar este servicio como <b>NO facturable</b>? 
                            No aparecerá para facturación.
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                setSelectedServicio(s => ({ ...s!, facturable: false }));
                                setConfirmNoFacturable(false);
                            }}
                        >
                            Sí, continuar
                        </Button>
                        <Button onClick={() => setConfirmNoFacturable(false)}>
                            Cancelar
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* DESACTIVAR SERVICIO */}
                <Dialog open={modalDeleteServicio} maxWidth="sm">
                    <DialogTitle>{selectedServicio?.activo ? 'DESACTIVAR SERVICIO' : 'ACTIVAR SERVICIO'}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {selectedServicio
                                ? `¿Está seguro de que desea ${selectedServicio.activo ? 'desactivar' : 'activar'} el servicio "${selectedServicio.nombre}"?`
                                : 'Servicio no seleccionado.'}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={toggleServicioActivo} color="primary">SI</Button>
                        <Button onClick={() => { setModalDeleteServicio(false); setSelectedServicio(initialServicio); }} color="primary" autoFocus>NO</Button>
                    </DialogActions>
                </Dialog>

                {/* AÑADIR MÉTODO DE PAGO */}
                <Dialog open={modalMetodoPago} maxWidth="sm" fullWidth onClose={closeModalMetodoPago}>
                    <DialogContent>
                        <Typography variant="h4" sx={{ display: 'inline-flex' }}>
                            <Avatar sx={{ margin: theme.spacing(1), backgroundColor: '#2e7d32' }}>
                                <AddIcon />
                            </Avatar>
                            <div style={{ margin: '10px auto' }}>Añadir método de pago</div>
                        </Typography>

                        <Grid container spacing={2} sx={{ mt: 1 }}>
                            {/* Selección de método de pago */}
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    select
                                    label="Método de pago*"
                                    value={selectedMetodo?.codigo || ""}
                                    onChange={(e) => {
                                        const codigo = Number(e.target.value) as MetodoPagoCodigo;
                                        const metodoSeleccionado = metodosPagoDisponibles.find(m => m.codigo === codigo);
                                        
                                        if (metodoSeleccionado) {
                                            setSelectedMetodo(s => ({
                                                ...s!,
                                                nombre: metodoSeleccionado.nombre,
                                                codigo: metodoSeleccionado.codigo
                                            }));
                                            setErrorMetodo("");
                                        }
                                    }}
                                    error={Boolean(errorMetodo)}
                                    helperText={errorMetodo}
                                >
                                    {metodosPagoDisponibles.map((m) => {
                                        const yaExiste = metodosPago.some(mp => mp.codigo === m.codigo);
                                        return (
                                            <MenuItem key={m.codigo} value={m.codigo} disabled={yaExiste}>
                                                {m.nombre}
                                            </MenuItem>
                                        );
                                    })}
                                </TextField>
                            </Grid>
                        </Grid>
                    </DialogContent>

                    {loadingMetodo ? (
                        <Grid container>
                            <CircularProgress style={{ margin: '20px auto' }} />
                        </Grid>
                    ) : (
                        <DialogActions>
                            <Button onClick={() => {
                                if (!validateMetodoPago()) return;
                                saveMetodoPago();
                            }}>Guardar</Button>
                            <Button onClick={closeModalMetodoPago}>Cancelar</Button>
                        </DialogActions>
                    )}
                        
                </Dialog>

                {/* DESACTIVAR METODO DE PAGO */}
                <Dialog open={modalDeleteMetodo} maxWidth="sm">
                    <DialogTitle>{selectedMetodo?.activo ? 'DESACTIVAR MÉTODO DE PAGO' : 'ACTIVAR MÉTODO DE PAGO'}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {selectedMetodo
                                ? `¿Está seguro de que desea ${selectedMetodo.activo ? 'desactivar' : 'activar'} el método de pago "${selectedMetodo.nombre}"?`
                                : 'Método de pago no seleccionado.'}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={toggleMetodoPagoActivo} color="primary">SI</Button>
                        <Button onClick={() => { setModalDeleteMetodo(false); setSelectedMetodo(null) }} color="primary" autoFocus>NO</Button>
                    </DialogActions>
                </Dialog>

                {/* EDITAR DIVISA — se dispara desde el icono de la tarjeta de la entidad principal */}
                <Dialog open={modalCurrency} maxWidth="sm" fullWidth onClose={() => !loadingCurrency && setModalCurrency(false)}>
                    <DialogContent>
                        <Typography variant="h4" sx={{ display: 'inline-flex' }}>
                            <Avatar sx={{ margin: theme.spacing(1), backgroundColor: '#2e7d32' }}>
                                <AddIcon />
                            </Avatar>
                            <div style={{ margin: '10px auto' }}>Editar divisa</div>
                        </Typography>

                        <Grid container spacing={2} sx={{ mt: 1 }}>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                  <InputLabel id="currency-select-label">Divisa</InputLabel>
                                  <Select
                                    labelId="currency-select-label"
                                    value={inputCurrency}
                                    label="Divisa"
                                    disabled={loadingCurrency}
                                    onChange={(e) => setInputCurrency(e.target.value)}
                                  >
                                    {constantes.SUPPORTED_CURRENCIES.map(({ code, label }) => (
                                      <MenuItem key={code} value={code}>
                                        {label}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                                
                    {loadingCurrency ? (
                        <Grid container>
                            <CircularProgress style={{ margin: '20px auto' }} />
                        </Grid>
                    ) : (
                        <DialogActions>
                            <Button disabled={loadingCurrency} onClick={updateUserCurrency}>Guardar</Button>
                            <Button disabled={loadingCurrency} onClick={() => setModalCurrency(false)}>Cancelar</Button>
                        </DialogActions>
                    )}
                </Dialog>

                {/* ENTIDADES DE FACTURACIÓN */}
                <Grid container spacing={2} sx={{ p: 2 }}>
                    <Grid item xs={12}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                            Entidades de facturación
                        </Typography>
                    </Grid>
                                
                    {/* BOTÓN Y LÍMITE */}
                    <Grid item xs={12}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            {loadingPlan ? (
                                <Button
                                    color="success"
                                    variant="contained"
                                    disabled
                                    sx={{
                                        width: 'fit-content',
                                        minWidth: 170,
                                        minHeight: 36
                                    }}
                                >
                                    <CircularProgress
                                        size={20}
                                        sx={{ color: 'white' }}
                                    />
                                </Button>
                            ) : (
                                <Button
                                    onClick={() => {
                                        setSelectedEntidad(undefined);
                                        setModalEntidad(true);
                                    }}
                                    disabled={
                                        plan?.limit != null &&
                                        (entidadesAdicionales.filter(e => e.active).length + 1) >= plan.limit
                                    }
                                    color="success"
                                    variant="contained"
                                    sx={{ width: 'fit-content' }}
                                >
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            fontSize: '15px',
                                            fontWeight: 'bold',
                                            color: 'white'
                                        }}
                                    >
                                        Añadir entidad
                                    </Typography>
                                </Button>
                            )}
                
                            {plan?.limit != null && (
                                <Box>
                                    <Chip
                                        label={`${entidadesAdicionales.filter(e => e.active).length + 1} / ${plan.limit} entidades de facturación`}
                                        color={
                                            (entidadesAdicionales.filter(e => e.active).length + 1) < plan.limit
                                                ? 'success'
                                                : 'error'
                                        }
                                    />
                
                                    {(entidadesAdicionales.filter(e => e.active).length + 1) >= plan.limit && (
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1,
                                                mt: 1
                                            }}
                                        >
                                            <WarningAmberIcon
                                                sx={{
                                                    color: '#f44336',
                                                    fontSize: 20
                                                }}
                                            />
                
                                            <Typography variant="body2" color="error">
                                                Has alcanzado el límite de {plan.limit} entidades de facturación para tu plan.
                                            </Typography>
                                            
                                            <Button
                                                onClick={() => history(constantes.R_SUSCRIPCION)}
                                                variant="text"
                                                sx={{
                                                    textTransform: 'none',
                                                    color: '#1976d2',
                                                    fontWeight: 'bold',
                                                    p: 0,
                                                    minWidth: 0
                                                }}
                                            >
                                                Mejora el plan
                                            </Button>
                                        </Box>
                                    )}
                                </Box>
                            )}
                        </Box>
                    </Grid>
                        
                    {/* LISTADO DE TARJETAS */}
                    <Grid item xs={12}>
                        <Box
                            sx={{
                                display: 'grid',
                                gap: 2,
                                gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'repeat(2, minmax(0, 1fr))' },
                                gridAutoRows: '1fr'
                            }}
                        >
                            {/* ENTIDAD PRINCIPAL */}
                            {datosFacturacionPrincipal && (
                                    <Card variant="outlined" sx={{ display: 'flex', flexDirection: 'column' }}>
                                        <CardContent sx={{ flexGrow: 1 }}>
                                            <Typography
                                                variant="subtitle1"
                                                sx={{ fontWeight: 'bold' }}
                                            >
                                                {datosFacturacionPrincipal.nombre}{' '}
                                                <Chip
                                                    label="Principal"
                                                    size="small"
                                                    sx={{ ml: 1 }}
                                                />
                                            </Typography>
                            
                                            <Typography variant="body2">
                                                {datosFacturacionPrincipal.nif}
                                            </Typography>
                            
                                            <Typography variant="body2">
                                                {datosFacturacionPrincipal.calle},{' '}
                                                {datosFacturacionPrincipal.codigoPostal}{' '}
                                                {datosFacturacionPrincipal.ciudad}
                                            </Typography>
                            
                                            <Typography variant="body2">
                                                {constantes.paises.find(
                                                    p => p.id === datosFacturacionPrincipal.pais
                                                )?.name || datosFacturacionPrincipal.pais}
                                            </Typography>
                                            
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 0.5
                                                }}
                                            >
                                                <Typography variant="body2">
                                                    {constantes.SUPPORTED_CURRENCIES.find(
                                                        c => c.code === (currency || 'EUR')
                                                    )?.label || 'Euro (€)'}
                                                </Typography>
                                                
                                                <Tooltip title="Editar divisa">
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => {
                                                            setInputCurrency(currency || 'EUR');
                                                            setModalCurrency(true);
                                                        }}
                                                    >
                                                        <EditIcon fontSize="inherit" />
                                                    </IconButton>
                                                </Tooltip>
                                            </Box>
                                                    
                                            {entidadesAdicionales.length > 0 && (
                                                loadingContadores ? (
                                                    <Box sx={{ display: 'flex', mt: 1 }}>
                                                        <CircularProgress size={16} />
                                                    </Box>
                                                ) : (
                                                    <>
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                        >
                                                            {getUltimoNumero(null)}
                                                        </Typography>

                                                        {necesitaNuevoAnio(null) && (
                                                            <Alert
                                                                severity="warning"
                                                                sx={{ mt: 1 }}
                                                                action={
                                                                    <Button
                                                                        size="small"
                                                                        color="inherit"
                                                                        onClick={() => {
                                                                            setEntidadCambioAnio({ _id: null, pais: datosFacturacionPrincipal?.pais });
                                                                            setModalCambioAnio(true);
                                                                        }}
                                                                    >
                                                                        Actualizar
                                                                    </Button>
                                                                }
                                                            >
                                                                Necesita numeración nueva para {anioEnCursoDe(null)}
                                                            </Alert>
                                                        )}
                                                    </>
                                                )
                                            )}
                                        </CardContent>
                                        
                                        <CardActions>
                                            <Button
                                                size="small"
                                                onClick={() =>
                                                    history(constantes.R_SUSCRIPCION)
                                                }
                                            >
                                                Editar
                                            </Button>
                                        </CardActions>
                                    </Card>
                            )}

                            {/* ENTIDADES ADICIONALES */}
                            {entidadesAdicionales.map(entidad => (
                                    <Card
                                        key={entidad._id}
                                        variant="outlined"
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            backgroundColor: entidad.active
                                                ? 'white'
                                                : '#f0f0f0'
                                        }}
                                    >
                                        <CardContent sx={{ flexGrow: 1 }}>
                                            <Typography
                                                variant="subtitle1"
                                                sx={{ fontWeight: 'bold' }}
                                            >
                                                {entidad.nombre}{' '}
                                                {!entidad.active && (
                                                    <Chip
                                                        label="Inactiva"
                                                        size="small"
                                                        sx={{ ml: 1 }}
                                                    />
                                                )}
                                            </Typography>
                                            
                                            <Typography variant="body2">
                                                {entidad.nif}
                                            </Typography>
                                            
                                            <Typography variant="body2">
                                                {entidad.calle},{' '}
                                                {entidad.codigoPostal}{' '}
                                                {entidad.ciudad}
                                            </Typography>
                                            
                                            <Typography variant="body2">
                                                {constantes.paises.find(
                                                    p => p.id === entidad.pais
                                                )?.name || entidad.pais}
                                            </Typography>
                                            
                                            <Typography variant="body2">
                                                {constantes.SUPPORTED_CURRENCIES.find(
                                                    c => c.code === entidad.moneda
                                                )?.label || entidad.moneda}
                                            </Typography>
                                            
                                            {loadingContadores ? (
                                                <Box sx={{ display: 'flex', mt: 1 }}>
                                                    <CircularProgress size={16} />
                                                </Box>
                                            ) : (
                                                <>
                                                    <Typography
                                                        variant="body2"
                                                        color="text.secondary"
                                                    >
                                                        {getUltimoNumero(entidad._id)}
                                                    </Typography>

                                                    {/* Una desactivada no emite: su numeración se actualiza al activarla */}
                                                    {entidad.active && necesitaNuevoAnio(entidad._id) && (
                                                        <Alert
                                                            severity="warning"
                                                            sx={{ mt: 1 }}
                                                            action={
                                                                <Button
                                                                    size="small"
                                                                    color="inherit"
                                                                    onClick={() => {
                                                                        setEntidadCambioAnio(entidad);
                                                                        setModalCambioAnio(true);
                                                                    }}
                                                                >
                                                                    Actualizar
                                                                </Button>
                                                            }
                                                        >
                                                            Necesita numeración nueva para {anioEnCursoDe(entidad._id)}
                                                        </Alert>
                                                    )}
                                                </>
                                            )}
                                        </CardContent>
                                        
                                        <CardActions>
                                            <Button
                                                size="small"
                                                disabled={!entidad.active}
                                                onClick={() => {
                                                    setSelectedEntidad(entidad);
                                                    setModalEntidad(true);
                                                }}
                                            >
                                                Editar
                                            </Button>
                                            
                                            <Button
                                                size="small"
                                                color="error"
                                                onClick={() => {
                                                    setEntidadToToggle(entidad);
                                                    setModalToggleEntidad(true);
                                                }}
                                            >
                                                {entidad.active
                                                    ? 'Desactivar'
                                                    : 'Activar'}
                                            </Button>
                                        </CardActions>
                                    </Card>
                            ))}
                        </Box>
                    </Grid>
                </Grid>

                {modalEntidad && (
                    <EntidadFacturacionForm
                      open={modalEntidad}
                      onClose={() => setModalEntidad(false)}
                      userId={ConfigUtils.getUserId()}
                      entidad={selectedEntidad}
                      onSuccess={handleEntidadSuccess}
                    />
                )}

                {modalCambioAnio && entidadCambioAnio && (
                    <CambioAnioNumeracionDialog
                      open={modalCambioAnio}
                      onClose={() => setModalCambioAnio(false)}
                      userId={ConfigUtils.getUserId()}
                      entidadId={entidadCambioAnio._id}
                      serieActual={contadores.find(c => (c.entidadId ?? null) === entidadCambioAnio._id)?.serie ?? ''}
                      pais={entidadCambioAnio.pais}
                      onSuccess={(nuevoContador) => {
                          setContadores(prev => prev.map(c => (c.entidadId ?? null) === entidadCambioAnio._id ? nuevoContador : c));
                          setModalCambioAnio(false);
                          setAlert({ open: true, severity: 'success', msg: 'Numeración actualizada correctamente' });
                      }}
                    />
                )}

                {/* ACTIVAR / DESACTIVAR ENTIDAD DE FACTURACIÓN */}
                <Dialog open={modalToggleEntidad} maxWidth="sm" fullWidth onClose={() => !loadingToggleEntidad && setModalToggleEntidad(false)}>
                    <DialogContent>
                        <DialogContentText>
                          {entidadToToggle?.active
                            ? `¿Seguro que quieres desactivar la entidad "${entidadToToggle?.nombre}"? Las facturas ya emitidas con ella se podrán seguir consultando, pero no se podrán crear nuevas.`
                            : `¿Seguro que quieres activar la entidad "${entidadToToggle?.nombre}"? Podrás volver a crear facturas con ella.${avisoNumeracionAlActivar(entidadToToggle)}`}
                        </DialogContentText>
                    </DialogContent>
                    {loadingToggleEntidad ? (
                        <Grid container>
                            <CircularProgress style={{ margin: '20px auto' }} />
                        </Grid>
                    ) : (
                        <DialogActions>
                            <Button color="error" onClick={handleToggleEntidadActiva}>
                              {entidadToToggle?.active ? "Desactivar" : "Activar"}
                            </Button>
                            <Button onClick={() => setModalToggleEntidad(false)}>Cancelar</Button>
                        </DialogActions>
                    )}
                </Dialog>

                <Snackbar open={alert.open} autoHideDuration={6000} onClose={handleCloseAlert}>
                    <Alert variant="filled" onClose={handleCloseAlert} severity={alert.severity} sx={{ width: '100%' }}>{alert.msg}</Alert>
                </Snackbar>
            </Grid>
        );
    } catch (e: any) {
        const error: ILog = { method: 'Servicios.Component', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return (
            <Alert severity="error">{e.message}</Alert>
        );
    }
};

export default Servicios;